<script>
  import { onMount } from "svelte";
  import FeedList from './FeedList.svelte';
  
  const PAGE_SIZE = 10;
  const defaultPost = { title: "", uri: "", age: "", age_unit: "min." }
  
  export let url = '/p/news/posts.json';
  export let page = 1;
  export let have_tags = true;
  export let have_time = true;
  export let have_feed_list = false;
  export let have_kinds = true;
  export let feed_id = null;
  
  let tags = [];
  let posts = [];
  let offset = 0;
  //let final_url = url;
  let active_tag_index = 2;
  let loading = false;
  
  $: getNews
  
  function toggleTag(i) {
    tags.forEach((t) => t.active = false )
    tags[i].active = true;
    getNews();
  }
  
  
  function getTags() {
    fetch("/p/news/feeds_tags.json")
      .then(function(r) {
        if (r.ok) return r;
        throw Error(r.statusText);
      })
      .then(r => r.json())
      .then(data => {
        tags = data.data;
        if (!(tags instanceof Array)) {
          switch(data.count) {
            case 1:
              tags = [Object.assign({}, data.data)];
              break;
            default:
              tags = [];
          }
        }
      });
  }
  
  function collectActiveTagIds() {
    return  tags.filter((t) => t.active).map((t) => t.id).join(",");
  }
  
  function filterFeed(ev) {
    feed_id = ev.detail;
    getNews()
  }
  
  function getNews() {
    posts = [];
    let params = `?page=${page}`;
    if (tags.length)
      params += `&tags=${collectActiveTagIds()}`;
    if (feed_id)
      params += `&feed=${feed_id}`;
    loading = true;
  
    fetch(url + params)
      .then(function(r) {
        if (r.ok) return r;
        throw Error(r.statusText);
      })
      .then(r => r.json())
      .then(data => {
        if (!(data.data instanceof Array) && data.count == 1)
          posts = [Object.assign({}, defaultPost, data.data)];
        else {
          posts = [];
          for(var i in data.data) {
            posts.push(Object.assign({}, defaultPost, data.data[i]));
          }
        }
        posts = posts.sort((f, s) => { return f.age > s.age } );
  
        //console.log("cookie", cookie.get("news-refresh"));
        var now = new Date(); //new Date(oldDateObj.getTime() + diff*60000);
        var freshness = Math.round((((now - (new Date(cookie.get("news-refresh")))) % 86400000) % 3600000) / 60000);
        posts.forEach(function(p, index) {
          this[index]['favicon'] = getFavicon(this[index]['uri']);
          if (this[index]['age'] < freshness)
            this[index]['unseen'] = true;
          if (this[index].age >= 180) {
            this[index]['age'] = Math.floor(this[index].age/60);
            this[index]['age_unit'] = "hod.";
            if (this[index].age >= 48) {
              this[index]['age'] = Math.floor(this[index].age/24);
              this[index]['age_unit'] = "dny";
            }
          }
        }, posts);
  
        offset = PAGE_SIZE * (data.page - 1);
        window.scrollTo(0, 0);
        loading = false;
      })
      .catch(function(error) {
        console.log(error);
      });
  }
  
  function domainFromUri(uri) {
    var matches = uri.match(/^https?\:\/\/([^\/?#]+)(?:[\/?#]|$)/i);
    return matches && matches[1];
  }
  
  function getFavicon(link) {
    var domain = domainFromUri(link);
    if (!domain || !domain.length) return "";
    return `https://t1.gstatic.com/faviconV2?client=SOCIAL&type=FAVICON&fallback_opts=TYPE,SIZE,URL&url=http://${domain}&size=16`;
  }
  
  function changePage(p) {
    page = p;
    getNews();
  }
  
  function changeKind(k) {
    url = `/p/news/${k}.json`;
    getNews();
  }
  
  onMount(() => {
    if (have_tags)
      getTags();
    getNews();
    cookie.set("news-refresh", (new Date()).toString()) // getTime
  })
  
  export function dragstart(e) {
    var index = parseInt(e.target.getAttribute('index'));
    e.dataTransfer.setData("text/plain", JSON.stringify(posts[index]));
  }
</script>
<div class='row my-1'>
{#if have_kinds}
<div class='col-12'>
<div class='nav nav-tabs'>
<li class='nav-item'>
<a class:active='{url=='/p/news/posts.json'}' class='nav-link' href='#posts' on:click|preventDefault='{()=>changeKind('posts')}' on:keyup|preventDefault='{()=>changeKind('posts')}'>
Články
</a>
</li>
<li class='nav-item'>
<a class:active='{url=='/p/news/videos.json'}' class='nav-link' href='#videos' on:click|preventDefault='{()=>changeKind('videos')}' on:keyup|preventDefault='{()=>url=changeKind('videos')}'>
Videa
</a>
</li>
</div>
</div>
{/if}
<div class='col-12'>
<div class='shadow'>
{#if have_tags}
<div class='d-flex flex-row align-items-start pt-2 px-2'>
<select bind:value='{active_tag_index}' class='custom-select ui tags' on:change='{() => toggleTag(active_tag_index)}'>
{#each tags as tag, i}
<option value='{i}'>{tag.label}</option>
{/each}
</select>
</div>
{/if}
{#if have_feed_list == true}
<div class='w-100'>
<FeedList on:filterFeed='{filterFeed}'></FeedList>
</div>
{/if}
<ol class='list-group list-group-flush my-2'>
{#each posts as post, i}
{#if post.uri}
{#if post.video_id}
<li class:font-weight-bold='{post.unseen}' class='list-group-item border-0 d-flex p-1'>
<a class='d-none d-lg-block grab' draggable='true' href='{post.uri}' index='{i}' on:dragstart='{event => dragstart(event)}' target='_blank'>
<img class='m-1' src='{post.image}' width='144'>
</a>
<div class='my-1'>
<a class='d-block grab pl-2' draggable='true' href='{post.uri}' index='{i}' on:dragstart='{event => dragstart(event)}' target='_blank'>
{post.title}
<br>
<span class='d-flex flex-row'>
<span class='pl-4 badge badge-light d-inline-block px-3'>{post.channel_name}</span>
{#if have_time}
<span class='text-sm text-muted d-inline-block px-3'>před {post.age} {post.age_unit}</span>
{/if}
</span>
</a>
</div>
</li>
{:else}
<li class:font-weight-bold='{post.unseen}' class='list-group-item border-0'>
<a class='grab' draggable='true' href='{post.uri}' index='{i}' on:dragstart='{event => dragstart(event)}' target='_blank'>{post.title}</a>
<div class='d-flex flex-row justify-content-between'>
<span class='pl-4 badge badge-light' style='background: url({post.favicon}) left center no-repeat'>
{domainFromUri(post.uri)}
</span>
{#if have_time}
<span class='text-sm text-muted d-inline-block px-3'>před {post.age} {post.age_unit}</span>
{/if}
</div>
</li>
{/if}
{/if}
{/each}
</ol>
{#if posts.length}
<nav class='nav d-flex justify-content-around'>
{#if page-1 }
<a class='nav-link' href='#posts_page={page-1}' on:click|preventDefault='{() => changePage(page-1)}' tinro-ignore>
Předchozí strana
</a>
{:else}
<span class='nav-link text-muted'>Předchozí strana</span>
{/if}
{#if posts.length }
<a class='nav-link' href='#posts_page={page+1}' on:click|preventDefault='{() => changePage(page+1)}' tinro-ignore>
Další strana
</a>
{:else}
<span class='nav-link text-muted'>Další strana</span>
{/if}
</nav>
{/if}
{#if !posts.length}
{#if loading}
<div class='jumbotron bg-white'>
<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 200 200"><circle fill="#18289C" stroke="#18289C" stroke-width="15" r="15" cx="40" cy="100"><animate attributeName="opacity" calcMode="spline" dur="2" values="1;0;1;" keySplines=".5 0 .5 1;.5 0 .5 1" repeatCount="indefinite" begin="-.4"></animate></circle><circle fill="#18289C" stroke="#18289C" stroke-width="15" r="15" cx="100" cy="100"><animate attributeName="opacity" calcMode="spline" dur="2" values="1;0;1;" keySplines=".5 0 .5 1;.5 0 .5 1" repeatCount="indefinite" begin="-.2"></animate></circle><circle fill="#18289C" stroke="#18289C" stroke-width="15" r="15" cx="160" cy="100"><animate attributeName="opacity" calcMode="spline" dur="2" values="1;0;1;" keySplines=".5 0 .5 1;.5 0 .5 1" repeatCount="indefinite" begin="0"></animate></circle></svg>
</div>
{:else}
<div class='alert alert-primary bg-light'>
Zde nic není.
</div>
{/if}
{/if}
</div>
</div>
</div>

